import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'app-new-maps',
  templateUrl: './new-maps.component.html',
  styleUrls: ['./new-maps.component.scss']
})
export class NewMapsComponent implements OnInit {
  title = 'AGM project';
  constructor(
    ) { }

  ngOnInit() {

  }



}
